import {
  POST,
  GET
} from '@/axios/axios'

export const services = {
  SystemMenuList: (param) => {    // 菜单管理列表
    return GET('/backend/role/findMenuByType', param)
  },
  SystemMenuSave: (param) => {   // 菜单管理-新增修改
    return POST('/backend/entity/save', param)
  },
  GenerateMenu: (param) => {     // 生成功能菜单
    return POST('/backend/entity/createButtons', param)
  },
  DisableMenu: (param) => {     // 停用菜单
    return GET('/backend/entity/deleteAll', param)
  },
  SystemMenuDelete: (param) => { // 菜单管理-删除
    return GET("/backend/entity/delete", param)
  }
}

export default services;



// WEBPACK FOOTER //
// ./src/service/services/menuManagement.js